import { render, staticRenderFns } from "./RecruitDetail.vue?vue&type=template&id=dd3240e4&scoped=true&"
import script from "./RecruitDetail.vue?vue&type=script&lang=js&"
export * from "./RecruitDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecruitDetail.vue?vue&type=style&index=0&id=dd3240e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3240e4",
  null
  
)

export default component.exports